import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@NgModule({

	imports: [
		CommonModule,
		NgbModule
	],

	exports: [
		NgbModule
	],

	declarations: [ ],

	providers: [
		NgbActiveModal
	]

})
export class BootstrapModule { }
